import { Column } from '@simplywallst/ui-core';
import ReactMarkdown from 'react-markdown';

import {
  JourneyContainerRow,
  StyledReactMarkdown,
  JourneyHeader,
  Timeline,
  Ellipse,
  Date,
} from './styled';
import { OneColumnExpanded } from '../../styled';

interface Props {
  title?: string;
  shortContentOne?: string;
  shortContentTwo?: string;
  shortContentThree?: string;
  shortContentFour?: string;
  markdownContent: string[];
}

export const Journey = ({
  title,
  markdownContent,
  shortContentOne,
  shortContentTwo,
  shortContentThree,
  shortContentFour,
}: Props) => {
  return (
    <JourneyContainerRow justifyContent="center">
      <OneColumnExpanded>
        <JourneyHeader data-cy-id="journey">
          <h2>{title}</h2>
        </JourneyHeader>
        <Timeline justifyContent="center">
          <Column colMd={3}>
            <Ellipse />
            <StyledReactMarkdown>
              <ReactMarkdown source={markdownContent[0]} />
            </StyledReactMarkdown>
            <Date>{shortContentOne}</Date>
          </Column>
          <Column colMd={3}>
            <Ellipse />
            <StyledReactMarkdown>
              <ReactMarkdown source={markdownContent[1]} />
            </StyledReactMarkdown>
            <Date>{shortContentTwo}</Date>
          </Column>
          <Column colMd={3}>
            <Ellipse />
            <StyledReactMarkdown>
              <ReactMarkdown source={markdownContent[2]} />
            </StyledReactMarkdown>
            <Date>{shortContentThree}</Date>
          </Column>
          <Column colMd={3}>
            <Ellipse />
            <StyledReactMarkdown>
              <ReactMarkdown source={markdownContent[3]} />
            </StyledReactMarkdown>
            <Date>{shortContentFour}</Date>
          </Column>
        </Timeline>
      </OneColumnExpanded>
    </JourneyContainerRow>
  );
};
